import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FACTURATION_ROUTE_PROVIDER } from './billing-route.provider';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [],
})
export class BillingConfigModule {
  static forRoot(): ModuleWithProviders<BillingConfigModule> {
    return {
      ngModule: BillingConfigModule,
      providers: [FACTURATION_ROUTE_PROVIDER],
    };
  }
}
